/// <summary>
/// This script handles all client-sided functions and events for the login page<br/>
/// Author: ARF<br />
/// Date: 10.9.2015<br />
/// Copyright ©: EUDT GmbH 2015 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 18.1.2016                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$(document).ready(function () {
    
    //fix the width of the caption line
    var w = parseInt($("#logo").width(), 10);
    $(".group .caption").width(parseInt($(".group .caption").width() - w - 12, 10));

    //show background-level
    $(".login-bg-level").each( function() {$(this).show(1000);});
    $("#divLoginBox").show();

    if (areCookiesEnabled() === false) {
        $("#divNoCookies").show();
        $("#divLogin,.language, #divViewSelection").hide();
    }
    $("#divNoJS").hide(0);

    if (window._sBrowserAgent === "Other" || window._sBrowserAgent === "Opera" || (window._sBrowserAgent === "MSIE" && window._sBrowserVersion < 9) || window._sBrowserAgent === "Mozilla" && window._sBrowserVersion < 5) {
        $("#divOldBrowser").show();
        $("#divLogin, .language,.login-info, #divViewSelection").hide();
    }

    var h = parseInt(window._iBrowserWidth / 2000 * 800);
    document.getElementById('Ebene_1').setAttribute("width", window._iBrowserWidth + "px");
    document.getElementById('Ebene_1').setAttribute("height",  h+ "px");


    //handle styles for mobile/web buttons
    setView();
   
    $("#ddl-lang-id").off("change").on("change", function () {
        window.VisualCoreService.setLanguage(parseInt($(this).val()), function (result) {

            if (result === null) {
                return null;
            }
            if (result === true) {
                window.location = window.location;
                return false;
            }
            return true;
        });
    });

    //adds the eventhandler for the language icons
    $(".lang-icon[data-id=" + window.USER_LANGID + "]").addClass('selected');
    $(".lang-icon").click(function () {
        window.VisualCoreService.setLanguage(parseInt($(this).attr("data-id")), function (result) {
            if (result !== null) {
                if (result === true) {
                    window.location = window.location;
                }
            }
        });
    });


    $(".btn-view-selection").button();
    $("#btn-view-mobile").click(function () { redirectToView(true); });
    $("#btn-view-web").click(function () { redirectToView(false); });

  ////  add the eventhandlers for the mobile/web view
  //    $("#btnGoMobile").click(function () {redirectToView(true);});
  //    $("#btnGoWeb").click(function () { redirectToView(false); });


      $("#ddlViewSelection").change(function () {
          if ($(this).find(':selected').data("type") === "goMobile") { redirectToView(true); }
          if ($(this).find(':selected').data("type") === "goWeb") { redirectToView(false); }
      });

});

function areCookiesEnabled() {
    /// <summary>
    /// Simple function which validates if the browser has cookies enabled
    /// </summary>
    var cookieEnabled = (navigator.cookieEnabled) ? true : false;
    
    if (typeof navigator.cookieEnabled == "undefined" && !cookieEnabled) {
        document.cookie = "testcookie";
// ReSharper disable once CoercedEqualsUsing
        cookieEnabled = (document.cookie.indexOf("testcookie") != -1) ? true : false;
    }
    return (cookieEnabled);
}

function setView() {
    /// <summary>
    /// This function reads the hidden 'mobile' tag and sets the styles for the mobile/web version buttons.
    /// </summary>
    var mobile;
    try {
        mobile = $("#mobile").html();
      
        if (mobile === "true") {
            $("#btn-view-web").show();
            //$("#ddlViewSelection option[data-type='goMobile']").prop("selected", true);
            $("#btnGoMobile").addClass("color-bg-secondary selected").removeClass("color-font-secondary");
            $("#btnGoWeb").removeClass("color-bg-secondary selected").addClass("color-font-primary");
            $("#logo").addClass("mobile");
        } else {
            $("#btn-view-mobile").show();
            //$("#ddlViewSelection option[data-type='goWeb']").prop("selected", "selected");
            $("#btnGoWeb").addClass("selected");
            $("#btnGoMobile").removeClass("selected");
            $("#logo").removeClass("mobile");
        }
        return true;
    } catch (ex) { window.writeError('setView', ex); return false }
}


function redirectToView(mobile) {
    /// <summary>
    /// This function takes the curent url and reloads the page with an added querystring.<br/>
    /// This querystring is used to set the new view state in the vb-class of the login page.
    /// </summary>
    var url;
    try {
        url = $(location).attr("href");

        var sem = url.indexOf("?") == -1 ? "?" : "&";
        

        if (mobile) {
            window.location.href = url + sem + "goMobile=true";
        } else {
            window.location.href = url + sem + "goWeb=true";
        }

    return true;
} catch (ex) { window.writeError('redirectToView', ex); return false }


}